export const SITE_TRAIT_NAME_OPTOUT_ALL_MESSAGES = 'optout_all_messages';
export const SITE_USER_TRAIT_NAME_OPTOUT_ALL_MESSAGES = 'optout_all_messages_user';

export const ANALYTICS_SOURCE_NAME = 'optoutAllMessages';
export const ANALYTICS_FETCH_SITE_OPTOUT_SUCCEEDED: 'optoutAllMessages.fetchSiteOptout succeeded' = `${ANALYTICS_SOURCE_NAME}.fetchSiteOptout succeeded`;
export const ANALYTICS_FETCH_SITE_OPTOUT_FAILED: 'optoutAllMessages.fetchSiteOptout failed' = `${ANALYTICS_SOURCE_NAME}.fetchSiteOptout failed`;
export const ANALYTICS_FETCH_SITE_USER_OPTOUT_SUCCEEDED: 'optoutAllMessages.fetchSiteUserOptout succeeded' = `${ANALYTICS_SOURCE_NAME}.fetchSiteUserOptout succeeded`;
export const ANALYTICS_FETCH_SITE_USER_OPTOUT_FAILED: 'optoutAllMessages.fetchSiteUserOptout failed' = `${ANALYTICS_SOURCE_NAME}.fetchSiteUserOptout failed`;

export const ANALYTICS_CHANNEL = 'postOffice';
export const TRACK_EVENT_TYPE = 'track';

export const FIRE_TRACK_ANALYTICS_DEBOUNCE_TIME = 100; // 0.1 second
